<template>
  <notification-drop-down-list-item
    :title="$t('Title')"
    icon="InboxIcon"
    color="success"
    @click-ntf="$emit('redirect', '/sms/inbox')"
  >
    <small>
      {{ $t('Msg', { from: notification.payload.from }) }}
      <br>
      <strong>
        <router-link
          to="/sms/inbox"
          class="link-plain">
          {{  $t('ViewAll') }}
        </router-link>
      </strong>
    </small>
  </notification-drop-down-list-item>
</template>

<script>
// Components
import NotificationDropDownListItem from '@/layouts/components/navbar/components/notifications/NotificationDropDownListItem.vue';

// Mixins
import notificationItemMixin from '@/layouts/components/navbar/components/notifications/mixins/notification-item.mixin';

export default {
  name: 'InboundSmsNotification',
  i18n: {
    messages: {
      en: {
        Title: 'New inbound message',
        Msg: 'You have received a new message from {from}.',
        ViewAll: 'View all inbound SMS messages',
      },
    },
  },
  components: {
    NotificationDropDownListItem,
  },
  mixins: [notificationItemMixin],
};
</script>

<style scoped>

</style>
